import { connect } from "react-redux";
import EmployeePosMapping from "./employeePosMapping"
import { bindActionCreators } from "redux";
import {
  fetchEmployeePosDevices
} from "services/redux/installation/tagDelivery/action";

const mapStateToProps = (state) => ({
  posEmployeeDetails: state.tagDeliveryReducer.posEmployeeData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchEmployeePosDevices
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePosMapping);
